/**
 * Homepage — Three Marks–inspired motion (index only).
 * Letter-by-letter 3D front reveal + scroll staggers. Respects prefers-reduced-motion.
 */
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var LETTER_SELECTORS = [
    '.slideshow .hero__description',
    '.slideshow .hero__rte p',
    '[data-section-type="hero"] .hero__description',
    '.index-image-text .brick__block__text .hero__title',
    '[data-section-type="double"] .brick__block__text .hero__title'
  ];

  var BLOCK_SELECTORS = [
    '.index-rte .hero__media',
    '.index-image-text .brick__block__text .hero__rte',
    '[data-section-type="double"] .brick__block__text .hero__rte',
    '.index-image-text .brick__block__text .btn',
    '[data-section-type="double"] .brick__block__text .btn'
  ];

  function shouldSkip(el) {
    return !el || el.dataset.feMotion === 'done' || el.hasAttribute('data-aos') || el.closest('[data-aos]');
  }

  function splitLetters(el) {
    if (shouldSkip(el)) return null;
    if (el.closest('.fe-index-letters')) return null;

    var original = el.textContent.replace(/\s+/g, ' ').trim();
    if (!original) return null;

    el.dataset.feMotion = 'done';
    el.classList.add('fe-index-letters');
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', original);

    var letterIndex = 0;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach(function (node) {
      var text = node.textContent;
      if (!text) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i);
        var span = document.createElement('span');
        span.className = 'fe-index-letter' + (ch === ' ' || ch === '\u00a0' ? ' fe-index-letter--space' : '');
        span.textContent = ch === ' ' ? '\u00a0' : ch;
        span.style.setProperty('--fe-letter-i', String(letterIndex));
        if (!reduceMotion) span.setAttribute('aria-hidden', 'true');
        frag.appendChild(span);
        letterIndex++;
      }
      node.parentNode.replaceChild(frag, node);
    });

    return el.querySelectorAll('.fe-index-letter');
  }

  function markBlock(el, delayIndex) {
    if (shouldSkip(el)) return;
    el.dataset.feMotion = 'done';
    el.classList.add('fe-index-reveal');
    if (delayIndex % 3 === 1) el.classList.add('fe-index-reveal--delay-1');
    if (delayIndex % 3 === 2) el.classList.add('fe-index-reveal--delay-2');
  }

  function activateProductsSync(root) {
    if (!root) return;
    var grids = root.querySelectorAll('[data-products-sync]');
    if (!grids.length && root.hasAttribute && root.hasAttribute('data-products-sync')) {
      grids = [root];
    }
    grids.forEach(function (grid) {
      grid.classList.add('products-sync-ready');
    });
  }

  function isCarouselProduct(el) {
    return !!(el && el.closest('[data-grid-slider], .grid--slider'));
  }

  function markStagger(items, baseClass) {
    items.forEach(function (el, i) {
      if (shouldSkip(el)) return;
      el.dataset.feMotion = 'done';
      // Horizontal carousels clip off-screen slides; IntersectionObserver never
      // reaches the 12% threshold so those cards stay at opacity:0 forever.
      if (isCarouselProduct(el)) return;
      el.classList.add(baseClass);
      el.style.setProperty('--fe-stagger-i', String(i));
    });
  }

  var letterParents = [];
  LETTER_SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      var letters = splitLetters(el);
      if (letters && letters.length) letterParents.push({ el: el, letters: letters });
    });
  });

  var blockNodes = [];
  BLOCK_SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      blockNodes.push(el);
    });
  });
  blockNodes.forEach(function (el, i) {
    markBlock(el, i);
  });

  var coffeeSection = document.querySelector('[data-coffee-home-sort]');
  var coffeeProducts = document.querySelectorAll('[data-coffee-home-sort] .product-item');
  var featuredSection = document.querySelector('.index-products:not([data-coffee-home-sort])');
  var featuredProducts = document.querySelectorAll('.index-products:not([data-coffee-home-sort]) .product-item');
  var articles = document.querySelectorAll('.blog-section .article');
  var coffeeUsesSlider = coffeeSection && coffeeSection.querySelector('.grid--slider');
  var featuredUsesSlider = featuredSection && featuredSection.querySelector('.grid--slider');

  /* Carousel items off-screen never hit IntersectionObserver — skip stagger there */
  if (!coffeeUsesSlider) {
    markStagger(coffeeProducts, 'fe-index-product-reveal');
  } else {
    coffeeProducts.forEach(function (el) {
      el.dataset.feMotion = 'done';
    });
  }

  if (!featuredUsesSlider) {
    markStagger(featuredProducts, 'fe-index-product-reveal');
  } else {
    featuredProducts.forEach(function (el) {
      el.dataset.feMotion = 'done';
    });
  }
  markStagger(articles, 'fe-index-article-reveal');

  var baristaSection = document.querySelector('[data-section-type="hero"]');
  if (baristaSection) baristaSection.classList.add('fe-index-barista-stage');

  var homeHeroPanel = document.querySelector('.fe-home-hero .fe-index-reveal');
  if (homeHeroPanel) homeHeroPanel.classList.add('is-visible');

  /* Above-the-fold + carousel grids must not wait for scroll */
  if (coffeeSection) activateProductsSync(coffeeSection);
  if (featuredSection) activateProductsSync(featuredSection);
  document.querySelectorAll('[data-grid-slider][data-products-sync], .grid--slider[data-products-sync]').forEach(function (grid) {
    grid.classList.add('products-sync-ready');
  });

  function revealLetters(letters) {
    letters.forEach(function (letter) {
      letter.classList.add('is-visible');
    });
  }

  function revealBlock(el) {
    el.classList.add('is-visible');
  }

  function showAll() {
    letterParents.forEach(function (item) {
      revealLetters(item.letters);
    });
    document.querySelectorAll('.fe-index-reveal, .fe-index-product-reveal, .fe-index-article-reveal').forEach(revealBlock);
    if (baristaSection) baristaSection.classList.add('is-visible');
  }

  function getCarouselStep(track, slides) {
    if (!slides.length) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slides[0].offsetWidth + gap;
  }

  function disconnectBroadcastArrowObserver(slider) {
    // Broadcast toggles arrow.disabled from first/last slide `.is-visible`.
    // That fights scroll-based state and can peg Next disabled on a peek.
    try {
      if (slider.firstLastSlidesObserver) {
        slider.firstLastSlidesObserver.disconnect();
        slider.firstLastSlidesObserver = null;
      }
    } catch (e) {}
  }

  function setArrowDisabled(btn, disabled) {
    if (!btn) return;
    if (btn.disabled !== disabled) btn.disabled = disabled;
    var aria = disabled ? 'true' : 'false';
    if (btn.getAttribute('aria-disabled') !== aria) {
      btn.setAttribute('aria-disabled', aria);
    }
    btn.classList.toggle('is-disabled', disabled);
  }

  function wireCarouselArrows(root) {
    if (!root || root.dataset.feArrowWired === '1') return;
    var slider = root.matches && root.matches('grid-slider') ? root : root.querySelector('grid-slider');
    var track = (slider || root).querySelector('[data-grid-slider], .grid--slider');
    if (!slider || !track) return;
    root.dataset.feArrowWired = '1';

    function getButtons() {
      return {
        prev: slider.querySelector('[data-button-prev]'),
        next: slider.querySelector('[data-button-next]')
      };
    }

    // Scroll position only — never observe the attributes we write (infinite loop).
    function syncArrowState() {
      disconnectBroadcastArrowObserver(slider);
      var buttons = getButtons();
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= maxScroll - 4;
      if (maxScroll <= 4) {
        atStart = true;
        atEnd = true;
      }
      setArrowDisabled(buttons.prev, atStart);
      setArrowDisabled(buttons.next, atEnd);
    }

    // Capture phase: replace Broadcast's handler (needs `.is-visible` sibling).
    slider.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('[data-button-arrow]');
        if (!btn || !slider.contains(btn)) return;

        var slides = Array.prototype.slice.call(track.querySelectorAll('[data-grid-item]'));
        if (!slides.length) return;

        var isPrev = btn.hasAttribute('data-button-prev');
        var isNext = btn.hasAttribute('data-button-next');
        if (!isPrev && !isNext) return;

        syncArrowState();
        if (btn.disabled) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var step = getCarouselStep(track, slides);
        if (!step) return;

        var currentIndex = 0;
        var best = Infinity;
        slides.forEach(function (slide, index) {
          var dist = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (dist < best) {
            best = dist;
            currentIndex = index;
          }
        });

        var targetIndex = isPrev ? currentIndex - 1 : currentIndex + 1;
        if (targetIndex < 0 || targetIndex >= slides.length) {
          var delta = isPrev ? -step : step;
          track.scrollBy({ left: delta, top: 0, behavior: 'smooth' });
        } else {
          track.scrollTo({
            top: 0,
            left: slides[targetIndex].offsetLeft,
            behavior: 'smooth'
          });
        }

        window.setTimeout(syncArrowState, 80);
        window.setTimeout(syncArrowState, 420);
      },
      true
    );

    track.addEventListener('scroll', syncArrowState, { passive: true });
    window.addEventListener('resize', syncArrowState);

    syncArrowState();

    // Arrows are often injected by Broadcast after connectedCallback — poll briefly,
    // then stop. Do not mutate slide classes or re-observe button attributes.
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      disconnectBroadcastArrowObserver(slider);
      var buttons = getButtons();
      if (buttons.prev || buttons.next) syncArrowState();
      if ((buttons.prev && buttons.next) || tries > 20) {
        window.clearInterval(timer);
        syncArrowState();
      }
    }, 150);
  }

  function initHomepageCarousels() {
    document.querySelectorAll('.index-products grid-slider, grid-slider').forEach(function (slider) {
      if (!slider.closest('.index-products') && !document.body.classList.contains('template-index')) return;
      wireCarouselArrows(slider);
    });
  }

  // Always wire carousels (even when motion is reduced / IO missing).
  initHomepageCarousels();

  // Broadcast may (re)create firstLastSlidesObserver after our first pass.
  document.addEventListener('theme:grid-slider:init', function (event) {
    var slider = event.target;
    if (!slider || slider.tagName !== 'GRID-SLIDER') return;
    disconnectBroadcastArrowObserver(slider);
    // Re-sync if we already wired this slider.
    if (slider.dataset.feArrowWired === '1') {
      var track = slider.querySelector('[data-grid-slider], .grid--slider');
      if (!track) return;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= maxScroll - 4;
      if (maxScroll <= 4) {
        atStart = true;
        atEnd = true;
      }
      setArrowDisabled(slider.querySelector('[data-button-prev]'), atStart);
      setArrowDisabled(slider.querySelector('[data-button-next]'), atEnd);
    } else {
      wireCarouselArrows(slider);
    }
  });

  if (reduceMotion || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var target = entry.target;

        if (target.classList.contains('fe-index-letters')) {
          revealLetters(target.querySelectorAll('.fe-index-letter'));
        } else if (target.classList.contains('fe-index-barista-stage')) {
          target.classList.add('is-visible');
          var desc = target.querySelector('.hero__description');
          if (desc && desc.classList.contains('fe-index-letters')) {
            revealLetters(desc.querySelectorAll('.fe-index-letter'));
          }
        } else if (target.hasAttribute('data-coffee-home-sort') || target.matches('[data-section-type="product-grid"]')) {
          activateProductsSync(target);
        } else if (target.classList.contains('fe-index-overlay')) {
          var overlayLetters = target.querySelector('.fe-index-letters');
          if (overlayLetters) {
            revealLetters(overlayLetters.querySelectorAll('.fe-index-letter'));
          }
        } else {
          revealBlock(target);
        }

        observer.unobserve(target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  letterParents.forEach(function (item) {
    observer.observe(item.el);
  });

  document.querySelectorAll('.fe-index-reveal, .fe-index-product-reveal, .fe-index-article-reveal').forEach(function (el) {
    observer.observe(el);
  });

  if (baristaSection) observer.observe(baristaSection);

  document.querySelectorAll('.fe-index-overlay').forEach(function (el) {
    observer.observe(el);
  });

  if (coffeeUsesSlider && coffeeSection) {
    observer.observe(coffeeSection);
  }

  if (featuredSection) observer.observe(featuredSection);
})();
